import React, { useState, useEffect } from 'react';
import { Wrapper, Footer, Title, SubTitle, ErrorUI } from 'components';
import { getAllAuthors } from 'services/profissionals';
import CardProfessional from './components/CardProfessional';
import Dropdown from './components/Dropdown';
import { Content, SearchContainer, SearchInput, FilterContainer, ProfessionalsGrid } from './style';
import Author from 'services/profissionals/models/author-interface';

const ModulesContent: React.FC = () => {
  const [professional, setProfessional] = useState<Author[]>([]);
  const [filteredProfessionals, setFilteredProfessionals] = useState<Author[]>([]);
  const [specialties, setSpecialties] = useState<Array<string>>();
  const [selectedSpeciality, setSelectedSpeciality] = useState<string>('');
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [reload, setReload] = useState<number>(0);

  useEffect(() => {
    (async () => {
      const localProfissionals = await getAllAuthors({
        is_active: true,
        with_courses: true,
      });

      setProfessional(localProfissionals.authors);
      setFilteredProfessionals(localProfissionals.authors);
      setSpecialties(localProfissionals.specialty);
    })();
  }, [reload]);

  const handleFilterSpecialty = async (specialty: string) => {
    if (!specialty) {
      setFilteredProfessionals(professional);
      return;
    }

    const localProfissionals = await getAllAuthors({
      specialty: specialty,
      with_courses: true,
      is_active: true,
    });
    setFilteredProfessionals(localProfissionals.authors);
  };

  useEffect(() => {
    handleFilterSpecialty(selectedSpeciality);
  }, [selectedSpeciality, professional]);

  useEffect(() => {
    if (!searchTerm) {
      handleFilterSpecialty(selectedSpeciality);
      return;
    }

    const filtered = professional.filter(prof => 
      prof.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      prof.info.specialty.some(spec => 
        spec.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
    setFilteredProfessionals(filtered);
  }, [searchTerm, professional, selectedSpeciality]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const renderProfessionals = (items: Author[]) => {
    if (items.length === 0)
      return (
        <ErrorUI
          errorText="Tente outro especialista no menu"
          boldText="ESPECIALIDADE"
        />
      );
    return (
      <ProfessionalsGrid>
        {items.map(item => (
          <CardProfessional key={item.author_id} professional={item} />
        ))}
      </ProfessionalsGrid>
    );
  };

  return (
    <>
      <Wrapper>
        <Content>
          <div className="header-content">
            <Title>PROFISSIONAIS</Title>
            <SubTitle>
              Conheça os profissionais de saúde que respaldam nossos conteúdos.
            </SubTitle>
          </div>
          
          <FilterContainer>
            <SearchContainer>
              <SearchInput
                type="text"
                placeholder="Buscar por nome ou especialidade"
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </SearchContainer>
            
            {specialties && specialties.length ? (
              <Dropdown
                specialty={selectedSpeciality}
                specialties={specialties}
                onChange={specialty => setSelectedSpeciality(specialty)}
                resetPage={() => {
                  setReload(reload => reload + 1);
                  setSelectedSpeciality('');
                  setSearchTerm('');
                }}
              />
            ) : null}
          </FilterContainer>
        </Content>
        
        {filteredProfessionals && filteredProfessionals.length
          ? renderProfessionals(filteredProfessionals)
          : null}
      </Wrapper>
      <Footer backgroundColor={'transparent'} hasLogo />
    </>
  );
};

export default ModulesContent;